import { useState } from 'react'
import { supabase } from '../config/supabase'
import toast from 'react-hot-toast'

export const useFileUpload = () => {
  const [uploading, setUploading] = useState(false)
  const [progress, setProgress] = useState(0)

  const uploadFile = async (file, path, bucket = 'course-resources') => {
    setUploading(true)
    setProgress(0)

    try {
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        throw new Error('File size must be less than 10MB')
      }

      const { data, error } = await supabase.storage
        .from(bucket)
        .upload(path, file, {
          cacheControl: '3600',
          upsert: false
        })

      if (error) throw error

      setProgress(100)
      return data
    } catch (error) {
      console.error('Error uploading file:', error)
      toast.error(error.message || 'Failed to upload file')
      throw error
    } finally {
      setUploading(false)
      setTimeout(() => setProgress(0), 1000)
    }
  }

  const deleteFile = async (path, bucket = 'course-resources') => {
    try {
      const { error } = await supabase.storage
        .from(bucket)
        .remove([path])

      if (error) throw error

      return { error: null }
    } catch (error) {
      console.error('Error deleting file:', error)
      toast.error('Failed to delete file')
      return { error }
    }
  }

  const getPublicUrl = (path, bucket = 'course-resources') => {
    const { data } = supabase.storage
      .from(bucket)
      .getPublicUrl(path)

    return data.publicUrl
  }

  return {
    uploadFile,
    deleteFile,
    getPublicUrl,
    uploading,
    progress
  }
}